import { forwardRef } from 'react'

import { TextContainer } from 'components/container'
import { Quote } from 'components/misc'
import { Title } from '../../styled'
import { Slideshow } from './slideshow'

export const Script = forwardRef<HTMLDivElement>((_, ref) => (
  <section ref={ref}>
    <TextContainer>
      <Title data-menu-title="татарская письменность">Татарская письменность</Title>
      <p>
        В Татарстане использовали несколько систем письма: арабицу, латиницу и кириллицу.
      </p>
      <p>
        Вплоть до 1920 года на территории Татарстана использовали алфавит на основе арабского алфавита, сейчас его называют "<Quote>иске имлә</Quote>" –
        старое письмо. В 1920 году письменность упростили, добавили
        дополнительные буквы, соответствующие звукам, которых нет в арабском.
        Она получила название "<Quote>яңа имлә</Quote>" – новое письмо.
      </p>
    </TextContainer>
    <Slideshow />
    <TextContainer>
      <p>
        Уже в 1927 году арабский алфавит упразднили и ввели "
        <Quote>яңалиф</Quote>" на основе латинской графики. Однако официальной
        письменностью татарского языка он пробыл лишь до 1939 года.
      </p>
      <p>
        В 1939 году латиницу заменили на кириллический алфавит с добавлением
        специальных графем. Его в Татарстане используют до сих пор. С 1980-х
        некоторые татарские лингвисты активно пытались вернуть латинскую версию
        алфавита. После распада СССР власти Татарстана несколько раз
        предпринимали попытку ввести латиницу, но Конституционный суд России сделать это не разрешил.
      </p>
    </TextContainer>
  </section>
))
